import { Outlet } from 'react-router-dom'
import { Box, Image } from '@mantine/core'

import classes from './PageLayout.module.css'

export function PageLayout() {
  return (
    <Box className={classes.container}>
      <Image alt="Rolan Wealth" className={classes.logo} src="/logo.svg" />

      <Outlet />
    </Box>
  )
}
